import { render, staticRenderFns } from "./PageAxepta.vue?vue&type=template&id=266e9e6c&scoped=true&"
import script from "./PageAxepta.vue?vue&type=script&lang=js&"
export * from "./PageAxepta.vue?vue&type=script&lang=js&"
import style0 from "./PageAxepta.vue?vue&type=style&index=0&id=266e9e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266e9e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266e9e6c')) {
      api.createRecord('266e9e6c', component.options)
    } else {
      api.reload('266e9e6c', component.options)
    }
    module.hot.accept("./PageAxepta.vue?vue&type=template&id=266e9e6c&scoped=true&", function () {
      api.rerender('266e9e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/axepta/PageAxepta.vue"
export default component.exports